

import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import Navbar from '../../common/Navbar';
import './index.scss';
import { connect } from "react-redux";
import {
    ThemeProvider,
    defaultTheme,
    Footer,
    LoadingScreen
} from '@nike/ruxac';

import { ToastContainer, toast } from 'react-toastify';
import { includeHistoryDetails } from '../../common/actions/dlaactions'
import 'bootstrap-css'
import '@nike/ruxac/styles';
import 'react-table/react-table.css';
import 'react-toastify/dist/ReactToastify.css';

import * as CostStandardConstants from './Constants';

import DropArea from '../../common/dropzone/index'
import FileStatus from '../status/index';

class COSTSTANDARDS extends Component {

    createHistoryButton() {

        let historyPageLabel = CostStandardConstants.SHOW_HISTORY_BUTTON_LABEL;
        if (this.props.includeHistory === true) {
            historyPageLabel = CostStandardConstants.HIDE_HISTORY_BUTTON_LABEL
        }
        return <button type="button" className="right btn btn-outline-primary btn-space" title="Handle History" onClick={() => this.props.includeHistoryDetails()}>{historyPageLabel}</button>
    }


  
    render() {

        const user = {
            name: this.props.auth.name,
            email: this.props.auth.email
        }
        const loading = false;
        return (

            !this.props.auth.hasAuthCheckFinished ? (this.props.auth.hasAuthCheckFinished === false ? "loading" : (<div>
                <Navbar text="Upload App"
                    user={user}
                    userOrgContent={`PES\u2011PCX`}
                />
                <div className="error-message-container"><h1>You are not an authorized user of this app.</h1></div>
            </div>)) : (<ThemeProvider theme={defaultTheme}>
                <div className="App">
                    <Navbar
                        user={user}
                        userOrgContent={`PES\u2011PCX`}
                    />
                    <div className="FileUpload">
                        <section>
                            <h3 className="left">
                                Upload File(s)
                                </h3>
                            {this.createHistoryButton()}

                        </section>
                        <br />
                    </div>
                    <section className="nike-container">
                        <DropArea includeHistory={this.props.includeHistory} maxLimit="10" maxRowLimit="500" />
                        <br></br>
                        <FileStatus />
                    </section>

                    <Footer />
                    <ToastContainer
                        position={toast.POSITION.TOP_RIGHT}
                    />

                    <LoadingScreen
                        isLoading={loading}
                        loadingMessage='Loading...' />
                </div>

            </ThemeProvider>
                )
        );
    }
}

COSTSTANDARDS.propTypes = {
    auth: PropTypes.object,
    includeHistory: PropTypes.bool.isRequired,

};

const mapStateToProps = state => ({
    auth: state.auth,
    includeHistory: state.dlareducer.includeHistory
});

const mapDispatchToProps = dispatch => bindActionCreators({

    includeHistoryDetails

}, dispatch);


export default connect(
    mapStateToProps,
    mapDispatchToProps


)(COSTSTANDARDS);





